import { RootState } from '../store';

export const selectRedirectUrl = (state: RootState): string | null =>
  state.redirect.redirectUrl;
